import React, { Component } from 'react';
import Heading from '../../elements/Heading';
import animations from './animations';

class Hero extends Component {

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props && this.props.dataReceived) {
            animations.initialise(this);
        }
    }

    render() {
        const LeadCopy = this.props.leadCopy ? this.props.leadCopy.map((paragraph, key) => {
            return (
                <p key={key} dangerouslySetInnerHTML={{ __html: paragraph }} />
            );
        }) : "";

        return (
            <section className="hero" ref={el => this.container = el}>
                <div className={'hero-bg ' + (this.props.addClass ? this.props.addClass : '')}/>
                <div className="row">
                    <div className={`main-hero-column col-md-5 col-md-offset-1 col-xs-12 text-sm-center text-xs-center ${this.props.type}`}>
                        <Heading title={this.props.title} subTitle={(this.props.subTitle ? this.props.subTitle : null)} leadCopy={this.props.leadCopy} type={this.props.type} />
                        <div className="hero-copy">
                            {LeadCopy}
                        </div>
                        {(this.props.children ? this.props.children : '')}
                    </div>
                </div>
				{this.props.promo ? this.props.promo : ''}
            </section>
        );
    }

}

export default Hero;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Hero/Hero.js